import { generateTestId } from "@client-shared";

export const setApprovalRequestResultLineTestId = (index: number): string => generateTestId("ApprovalRequestResults", `line-${index}`);

export const setApprovalRequestRecordNameTestId = (index: number): string =>
  generateTestId("ApprovalRequestResults", `record-name-${index}`);
